<template>
  <b-card
    no-body
    v-draggable
    ref="mobile_subcard"
    id="mobile-subcard"
  >
    <!-- Header -->
    <b-card-header
      style="color: lightgrey; height: 25px; cursor: move"
      class="pl-2 pb-0 pt-0"
      header-tag="div"
      header-bg-variant="dark"
    >
      <b-row class="mx-0 px-0">
        <b-col class="mx-0 px-0" cols="11">
          mobile.de
          <span v-if="isCompetitor"
            >-
            {{ $t("Webportal.CX.Dashboard.Exploration.Competitor") }}</span
          >
        </b-col>
        <b-col class="mx-0 px-0" cols="1" style="text-align: right">
          <font-awesome-icon
            class="mx-1 clickable"
            :icon="['far', 'times']"
            @click="close()"
          />
        </b-col>
      </b-row>
    </b-card-header>

    <!-- Content -->
    <div v-if="isLoading" :class="{ spinner: isLoading }" style="height:200px"></div>
    <b-card-text
      v-else-if="MobileData != null" 
      class="pl-3 pr-3" 
      style="max-height: 90vh; overflow: auto"
    >
      <!-- Top menu -->
      <b-row>
        <b-col cols="11" class="subcard-title mb-3">
          {{ headLine || MobileData.Name }}
        </b-col>
      </b-row>

      <b-button-group>
        <CompetititorDropbox
          v-if="MobileData.Competitors && MobileData.Competitors.length > 0"
          :competitorList="MobileData.Competitors"
          @openCompetitor="openCompetitor"
        />
        <b-button target="_blank" rel="noopener" v-if="mobileURL || (MobileData.Mobile && MobileData.Mobile.MobileURL)" :href="mobileURL || MobileData.Mobile.MobileURL">
          <font-awesome-icon
            style="height: 15px; width: 15px"
            :icon="['far', 'external-link']"
          />
          {{ $t("Webportal.CX.Explorations.Mobile.MobileLink")}}
        </b-button>
      </b-button-group>

      <template v-if="!isCompetitor">
        <ScoresChart :Scores="MobileData.OverallScores" :Width="650"/>
        <hr>
        <table class="table mb-0 app-ctrl" v-if="MobileData.Ratings">
          <tr >
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.History") }}</th>
            <th class="border-top-0" colspan="3">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </tr>
          <RatingTableRow
            v-for="item in MobileData.Ratings"
            :key="item.title"
            :translationPrefix="'Webportal.CX.Dashboard.Exploration.Mobile.'"
            :Title="item.RatingTypeName"
            :Ratings="item.RatingTypeResults" />
        </table>
        <hr>
      </template>
      <template v-else>
        <div class="overallscore mb-3">
          <span class="label">{{ $t("Webportal.CX.Exploration.OverallScore")}}</span>
          <span class="value">{{MobileData.Mobile.Ratings.find(r => r.Name == 'OverallScore').Value}} <b-icon icon="star-fill" class="text-warning"></b-icon></span>
        </div>

        <table class="table mb-0">
          <thead>
            <th class="border-top-0">{{ $t("Webportal.CX.Explorations.RatingsLabel") }}</th>
            <th class="border-top-0" colspan="2">{{ $t("Webportal.CX.Dashboard.Exploration.CurrentValue") }}</th>
          </thead>
          <template v-for="rating in MobileData.Mobile.Ratings.filter(r => r.Name != 'OverallScore')">
            <CompetitorRatingTableRow 
              :rating="rating"
              :key="rating.Name"
              :translationPrefix="'Webportal.CX.Dashboard.Exploration.Mobile.'"/>
          </template>              
        </table>

        <hr>
      </template>

      <!-- Reviews -->
      <div v-if="Reviews.length <= 0" class="pb-3">
        {{ $t("Webportal.CX.Dashboard.Exploration.NoReviews") }}
      </div>

      <div v-else>
        <p style="color: grey; font-size: 0.9rem">
          {{ ReviewCount }}
          {{ $t("Webportal.CX.Dashboard.Exploration.Mobile.Reviews") }}
        </p>
        <p>{{ $t("Webportal.CX.Dashboard.Exploration.LatestReviews") }}:</p>
        <div class="pb-4" style="overflow: auto; height: 50%">
          <Accordion
            v-for="(review, index) in Reviews"
            :key="index"
            :toggleCols="1"
            class="mb-2"
          >
            <b-row
              slot="short"
              class="mb-2 pr-0 mr-0"
              style="width: 100%; font-size: 0.8"
            >
              <b-row
                class="m-0 mb-3 p-0"
                style="
                  font-size: 1rem;
                  line-height: 1;
                  width: 100%;
                  font-weight: 600;
                "
              >
                <b-col>
                  <span>{{ new Date(review.Time).toLocaleDateString() }}</span>
                </b-col>
                <b-col cols="8">
                  <span>{{ review.AuthorName }}</span>
                </b-col>
              </b-row>

              <b-row class="m-0 p-0" style="width: 100%">
                <!-- Review rating: Response Time -->
                <b-col class="p-0" cols="3" v-if="review.ResponseTime">{{
                  $t(
                    "Webportal.CX.Dashboard.Exploration.Mobile.ResponseTime"
                  )
                }}</b-col>
                <b-col class="p-0 pr-2" cols="3" v-if="review.ResponseTime"
                  ><b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.ResponseTime"
                /></b-col>

                <!-- Review checkbox: Recommended -->
                <b-col
                  class="pr-2 text-success"
                  cols="1"
                  v-if="review.Recommend === true"
                >
                  <font-awesome-icon :icon="['far', 'check']" />
                </b-col>
                <b-col
                  class="pr-2 text-danger"
                  cols="1"
                  v-else-if="review.Recommend === false"
                >
                  <font-awesome-icon :icon="['fas', 'exclamation']" />
                </b-col>
                <b-col class="p-0" v-if="review.Recommend != null" cols="5">
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Mobile.Recommendation"
                    )
                  }}
                </b-col>
              </b-row>

              <b-row class="m-0 p-0" style="width: 100%">
                <!-- Review rating: Friendliness -->
                <b-col cols="3" class="p-0" v-if="review.Friendliness">{{
                  $t(
                    "Webportal.CX.Dashboard.Exploration.Mobile.Friendliness"
                  )
                }}</b-col>
                <b-col class="p-0 pr-2" cols="3" v-if="review.Friendliness"
                  ><b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Friendliness"
                  ></b-form-rating
                ></b-col>
                <!-- Review checkbox: AdReality -->
                <b-col
                  class="pr-2 text-success"
                  cols="1"
                  v-if="review.AdReality === true"
                >
                  <font-awesome-icon :icon="['far', 'check']" />
                </b-col>
                <b-col
                  class="pr-2 text-danger"
                  cols="1"
                  v-else-if="review.AdReality === false"
                >
                  <font-awesome-icon :icon="['fas', 'exclamation']" />
                </b-col>
                <b-col v-if="review.AdReality != null" class="p-0" cols="5">
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Mobile.AdReality"
                    )
                  }}
                </b-col>
              </b-row>

              <b-row class="m-0 mb-2 p-0" style="width: 100%">
                <!-- Review rating: Consulting -->
                <b-col cols="3" class="p-0" v-if="review.Consulting">{{
                  $t("Webportal.CX.Dashboard.Exploration.Mobile.Consulting")
                }}</b-col>
                <b-col class="p-0 pr-2" cols="3" v-if="review.Consulting"
                  ><b-form-rating
                    variant="warning"
                    class="m-0 p-0 app-ctrl"
                    no-border
                    readonly
                    size="sm"
                    :value="review.Consulting"
                  ></b-form-rating
                ></b-col>
                <!-- Bought car -->
                <template v-if="review.BoughtCar === true">
                  <b-col class="pr-2 text-success" cols="1">
                    <font-awesome-icon :icon="['far', 'check']" />
                  </b-col>
                  <b-col cols="5" class="p-0">
                    {{
                      $t(
                        "Webportal.CX.Dashboard.Exploration.Mobile.BoughtCar"
                      )
                    }}
                  </b-col>
                </template>
                <!-- Not bought -->
                <template v-else-if="review.BoughtCar === false">
                  <b-col class="pr-2 text-danger" cols="1">
                    <font-awesome-icon :icon="['fas', 'times']" />
                  </b-col>
                  <b-col cols="5" class="p-0">
                    {{
                      $t(
                        "Webportal.CX.Dashboard.Exploration.Mobile.BoughtCar"
                      )
                    }}
                  </b-col>
                </template>
                <!-- Other car bought -->
                <template v-else>
                  <b-col class="pr-2 text-warning" cols="1">
                    <font-awesome-icon :icon="['fas', 'exclamation']" />
                  </b-col>
                  <b-col cols="5" class="p-0">
                    {{
                      $t(
                        "Webportal.CX.Dashboard.Exploration.Mobile.BoughtAnotherCar"
                      )
                    }}
                  </b-col>
                </template>
              </b-row>
            </b-row>

            <!-- Review text message -->
            <template slot="long">
              <div v-if="review.LikeText">
                <h6>
                  {{
                    $t("Webportal.CX.Dashboard.Exploration.Mobile.Likes")
                  }}
                </h6>
                <p class="mb-2">{{ review.LikeText }}</p>
                <hr v-if="review.DislikeText" />
              </div>

              <div v-if="review.DislikeText">
                <h6>
                  {{
                    $t("Webportal.CX.Dashboard.Exploration.Mobile.Dislikes")
                  }}
                </h6>
                <p class="mb-2">{{ review.DislikeText }}</p>
              </div>

              <!-- Reply of retailer -->
              <div v-if="review.ReplyText">
                <hr v-if="review.LikeText || review.DislikeText" />
                <h6>
                  <span v-if="review.ReplyTime">{{ new Date(review.ReplyTime).toLocaleDateString() }} - </span>
                  {{
                    $t(
                      "Webportal.CX.Dashboard.Exploration.Mobile.RetailerReply"
                    )
                  }}:
                </h6>
                <p class="mb-2">{{ review.ReplyText }}</p>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Accordion from "../Accordion";
import RatingDistribution from "./RatingDistribution";
import DashboardService from "@/services/DashboardService";
import CompetititorDropbox from "./CompetitorDropbox";
import RatingTableRow from "@/components/CX/ExplorationCard/RatingTableRow";
import TrendIcon from "@/components/Shared/TrendIcon";
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";
import ScoresChart from "@/components/CX/ExplorationCard/ScoresChart";
import CompetitorRatingTableRow from "@/components/CX/CompetitorRatingTableRow";

export default {
  name: "MobilePopup",
  components: {
    Accordion,
    RatingDistribution,
    CompetititorDropbox,
    RatingTableRow,
    TrendIcon,
    AccomplishmentIcon,
    ScoresChart,
    CompetitorRatingTableRow
  },
  props: {
    mobileData: {
      type: Object,
      default: () => {}
    },
    headLine: String,
    isCompetitor: Boolean,
    competitorId: Number,
    mobileURL: String
  },
  data() {
    return {
      MobileData: null,
      isLoading: true
    };
  },
  computed: {
    CurrentOverallScore() {
      var currentDate = new Date(Date.now());
      var currentScore = this.MobileData?.OverallScores?.find( x => x.Year == currentDate.getFullYear() && x.Month == (currentDate.getMonth() + 1));
      return currentScore.Value;
    },
    ReviewCount: function() {
      return (
        this.RatingsByName?.ActiveRatingsCount?.Value ||
        this.Reviews?.length ||
        0
      );
    },
    Reviews: function() {
      return this.MobileData?.Reviews || this.MobileData?.Mobile?.Reviews || [];
    },
    Ratings: function() {
      return this.MobileData?.Ratings || this.MobileData?.Mobile?.Ratings || [];
    },
    RatingsByName: function() {
      return (
        this.MobileData?.RatingsByName ||
        this.MobileData?.Mobile?.RatingsByName ||
        {}
      );
    },
    OverallScore: function() {
      return (
        this.MobileData?.Threshold?.Value ||
        this.RatingsByName?.OverallScore?.Value ||
        0
      );
    },
    PercentRecommend: function() {
      return this.RatingsByName?.PercentRecommend?.Value || 0;
    },
    PercentAdReality: function() {
      return this.RatingsByName?.PercentAdReality?.Value || 0;
    }
  },
  created: function() {
    window.addEventListener('keyup', this.handleKeyUp);
  },
  mounted: function() {
    if (this.isCompetitor) {
      this.getCompetitor(this.competitorId).then(response => {
        this.MobileData = response.data;

        if (this.MobileData.Mobile) {
          this.MobileData.Mobile.RatingsByName = _.keyBy(
            this.MobileData.Mobile.Ratings,
            "Name"
          );
        }
      }).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.MobileData = { ...this.mobileData };
    // use setTimeout() to await next event cycle/finished building
    window.setTimeout(() => {this.isLoading = false}, 0);
    }
  },
  methods: {
    openCompetitor(id) {
      this.$emit("open-competitor", id);
    },
    getCompetitor(competitorId) {
      return DashboardService.getCompetitor(competitorId, { mobile: true });
    },
    customizeTooltip(arg) {
      var dateString = new Date(arg.argument).toLocaleString('default', {month: 'short', year: 'numeric'});
      return {
        text: `${dateString}\n${arg.value}`
      };
    },
    close() {
      window.removeEventListener('keyup', this.handleKeyUp);
      this.$emit('close');
    },
    handleKeyUp(event) {
      if (event.key == 'Escape') {
        this.close();
      }
    },
  }
};
</script>

<style scoped>
.subcard-title {
  font-size: 1.5rem;
}
#mobile-subcard {
  position: fixed !important;
}
td span {
  text-align: right;
  display: inline-block;
  min-width: 4rem;
}
.mobile-popup {
  width: 700px;
}
</style>
